module.exports = __webpack_public_path__ + "static/media/photo_automotive.de360f8d.jpg";